import styled from "styled-components";
import { getTheme, Box, FlexBox, FlexFlow, FlexStream, Text, } from "@bracket/ui";
import type { ReactNode, } from "react";
import type { FlexAlignment, } from "@bracket/ui/types";



export declare type RasaCardCellProps = {
	label?: string;
	grow?: number;
	align?: FlexAlignment;
	justify?: FlexAlignment;
	children: ReactNode;
};


export const RasaCardCell = ({
	label,
	grow,
	align = "center",
	justify = "center",
	children, }: RasaCardCellProps) => {

	return (
		<RasaCardCellFrame $grow={grow} $justify={justify} $align={align}>
			<LabelBox><Text bold>{label}</Text></LabelBox>
			<ValueBox>{children}</ValueBox>
		</RasaCardCellFrame>
	);
};

const LabelBox = styled(FlexStream)`
  flex: 1;
  align-items: center;
	justify-content: flex-end;
	white-space: nowrap;
`;

const ValueBox = styled(FlexStream)`
	flex: 1;
	align-items: center;
	justify-content: flex-start!important;
	> div {
	 justify-content: flex-start!important;
	}
`;

const RasaCardCellFrame = styled(FlexStream)<{ $basisPx?: number; $grow?: number; $justify: FlexAlignment; $align?: FlexAlignment; }>`
	align-items: ${({ $align }) => $align};
	justify-content: ${({ $justify }) => $justify};
	padding: 10px 0 10px 0;
	flex: 1 1 ${({ $basisPx }) => `${$basisPx}px`};
	min-width: 0;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-bottom: 1px solid ${() => getTheme().surface_container_high};
	flex-direction: row;
	width: 100%;
	white-space: normal;
	border-bottom: none;
	padding:0;
	gap: 0.25rem;
	p {
		font-size: 0.75rem;
	}
`;
